import FeedbackContainer from "./FeedbackContainer";
import FeedbackStore from "./FeedbackStore";
export default FeedbackStore(FeedbackContainer); 
